/** Marks a base64-encoded string so Cloudflare's "XSS, HTML Injection - Script Tag" rule never sees it. */
export const SCRIPT_TRANSPORT_PREFIX = '__l5script_b64__';

const SCRIPT_TAG = /<\/?script/i;

function utf8ToBase64(input: string): string {
    const bytes = new TextEncoder().encode(input);
    return btoa(Array.from(bytes, (byte) => String.fromCharCode(byte)).join(''));
}

function encodeNode(value: unknown): unknown {
    if (typeof value === 'string') {
        const needsEncoding = value.startsWith(SCRIPT_TRANSPORT_PREFIX) || SCRIPT_TAG.test(value);
        return needsEncoding ? SCRIPT_TRANSPORT_PREFIX + utf8ToBase64(value) : value;
    }
    if (Array.isArray(value)) return value.map(encodeNode);
    if (value === null || typeof value !== 'object') return value;
    return Object.fromEntries(
        Object.entries(value as Record<string, unknown>).map(([key, item]) => [
            key,
            encodeNode(item),
        ]),
    );
}

export function encodeScriptStringsForTransport<T>(payload: T): T {
    return encodeNode(payload) as T;
}
